export interface PaymentPricing {
   selectedTierId: number
   seatsCount: number
   maxSpend: number
   newLeadBudget: number
   reactivateLeadBudget: number
}

/** Stored records can predate these fields; never turn missing amounts into charges. */
export function isPaymentPricingReady(value: unknown): value is PaymentPricing {
   if (!value || typeof value !== 'object') return false
   const pricing = value as Record<string, unknown>
   const positiveInteger = (v: unknown) =>
      typeof v === 'number' && Number.isSafeInteger(v) && v > 0
   const amount = (v: unknown) =>
      typeof v === 'number' && Number.isFinite(v) && v >= 0

   return (
      positiveInteger(pricing.selectedTierId) &&
      positiveInteger(pricing.seatsCount) &&
      amount(pricing.maxSpend) &&
      amount(pricing.newLeadBudget) &&
      amount(pricing.reactivateLeadBudget)
   )
}
